/** Does this look like an email address at all?
 *
 * The shallow check the browser can make before spending a round trip: one
 * `@`, something either side, and a dotted domain. Deliberately not an
 * RFC 5322 parser — seekr's validator is the authority on whether an address
 * is acceptable, and a client-side rule stricter than that one would refuse
 * addresses the server would take.
 */
function looksLikeEmailAddress(value: string): boolean {
  return /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/.test(value.trim());
}

export { looksLikeEmailAddress };
